<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box">
      <div class="select-label">查看用户下的小程序:</div>
      <Select style="width:200px" clearable @on-clear="clearAppId" @on-change="changeAppId">
        <Option v-for="item in appList" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'testUsers',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      selectItems: [],
      sdkVersion: [],
      role: [
        { name: '超级管理员', val: 1 },
        { name: '管理员', val: 2 },
        { name: '普通用户', val: 3 }
      ],
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: 'userID',
          key: 'id',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '微信昵称',
          key: 'nickname',
          minWidth: 200
        },
        {
          title: '用户权限帐号',
          key: 'username',
          minWidth: 200,
          render: (h, params) => {
            if (params.row.username) {
              return h('Button', {
                props: {
                  type: ''
                },
                on: {
                  'click': (data) => {
                    sessionStorage.setItem('user_name_auth', params.row.username)
                    this.$router.push({
                      name: 'esApp'
                    })
                  }
                }
              }, params.row.username)
            }
          }
        },
        {
          title: '用户状态',
          key: 'apps',
          minWidth: 200,
          render: (h, params) => {
            if (params.row.apps) {
              return params.row.apps.map(item => {
                return h('Tag', `${item.name || ''}_${item.package_ver || ''}`)
              })
            }
          }
        },
        {
          title: '头像',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('img', {attrs: {
              src: params.row.avatar
            },
            style: {
              width: '50px',
              height: '50px'
            }
            })
          }
        },
        {
          title: '最后访问时间',
          key: 'updated_at',
          minWidth: 200
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.status === 1,
                  trueColor: '#13ce66'
                },
                on: {
                  'on-change': (data) => {
                    this.editData({
                      id: params.row.id,
                      status: data ? 1 : 2
                    })
                  }
                }
              }, '拒绝')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      appList: [],
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
    this.getAppList()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    loadData (id = '') {
      https.request({
        method: 'get',
        url: '/v1/test/account',
        params: {
          query: id,
          page_size: 40
        }
      }).then(res => {
        this.tableLoading = false
        this.dataSource = res.data.list || []
        this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    editData (params) {
      https.request({
        method: 'put',
        url: `/v1/test/account/${params.id}`,
        data: {
          status: params.status
        }
      }).then(res => {
        this.$Message.success('设置成功')
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    getAppList (id = '') {
      let params = {
        page_size: 200,
        page: 1
      }
      https.request({
        method: 'get',
        url: '/v1/tvp/list',
        params: params
      }).then(res => {
        this.appList = res.data.list
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    changeAppId (val) {
      this.loadData(val)
    },
    clearAppId () {
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/testUsers.vue